import { cleanObject } from '~/utils';
import qs from 'qs';

function initialOrder() {
    return {
        order_by: 'name',
        order_dir: 'asc',
    };
}

function initialFilters() {
    return {
        industries: [],
        university_uuids: null,
        job_type: null,
        location_type: null,
        qualification_type: null,
        relocate: null,
        gender_pronouns: null,
        languages: null,
        race_types: null,
        has_drivers_license: null,
        has_own_transport: null,
        location: null,
        location_radius: null,
        disability: null,
    };
}

export const state = () => ({
    candidates: [],
    candidate: null,
    filters: initialFilters(),
    order: initialOrder(),
    page: null,
});

export const mutations = {
    setCandidates(state: any, payload: any) {
        state.candidates = payload;
    },

    setCandidate(state: any, payload: object) {
        state.candidate = payload;
    },

    setCandidateProspectUuid(state: any, payload: object) {
        if (!state.candidate) return;
        return (state.candidate.prospect_uuid = payload);
    },

    setFilters(state: any, payload: object) {
        state.filters = payload;
    },

    setOrder(state: any, payload: object) {
        state.order = payload;
    },

    setPage(state: any, payload: number | null) {
        state.page = payload;
    },
};

export const getters = {
    getCandidates: (state: any) => state.candidates,

    getCandidate: (state: any) => state.candidate,

    getFilters: (state: any) => state.filters,

    getOrder: (state: any) => state.order,

    hasFilters: (state: any) => {
        let cleanFilters = cleanObject(state.filters);

        return Object.keys(initialFilters()).some((key) => {
            return Object.keys(cleanFilters).includes(key);
        });
    },
};

export const actions = {
    getCandidates(state: any) {
        // Don't return any candidates if the filters are empty.
        if (!state.getters.hasFilters) {
            state.commit('setCandidates', []);
            return new Promise((resolve) => resolve(false));
        }

        let payload = cleanObject({
            page: state.state.page,
            viewed: state.state.viewed ? 1 : 0,
            ...state.state.order,
            ...state.state.filters,
        });

        return new Promise((resolve, reject) => {
            this.$axios
                .get('/api/candidate/redacted-profiles', {
                    params: { ...payload },
                    paramsSerializer: (params) => {
                        return qs.stringify(params, { arrayFormat: 'indices' });
                    },
                })
                .then((res) => {
                    state.commit('setCandidates', res.data);
                    resolve(res.data);
                })
                .catch((err) => reject(err));
        });
    },

    getCandidate(state: any, candidate_uuid: string) {
        return new Promise((resolve, reject) => {
            this.$axios
                .get(`/api/candidate/profile/redacted/${candidate_uuid}`)
                .then((res) => {
                    state.commit('setCandidate', res.data);
                    resolve(res.data);
                })
                .catch((err) => reject(err));
        });
    },

    updateCandidateViewedStatus(state: any, candidate_uuid: string) {
        const candidates = JSON.parse(JSON.stringify(state.state.candidates));

        candidates.data = candidates.data.map((candidate) => {
            if (candidate.uuid === candidate_uuid) {
                candidate.viewed = true;
            }
            return candidate;
        });

        state.commit('setCandidates', candidates);
    },

    setCandidateProspectUuid(state: any, payload: object) {
        state.commit('setCandidateProspectUuid', payload);
    },

    setFilters(state: any, payload: object) {
        state.commit('setFilters', payload);
    },

    setOrder(state: any, payload: string) {
        state.commit('setOrder', payload);
    },

    setPage(state: any, payload: number | null) {
        state.commit('setPage', payload);
    },

    resetFilters(state: any) {
        state.commit('setFilters', initialFilters());
        state.commit('setCandidates', []);
        state.commit('setPage', null);
    },

    resetOrder(state: any) {
        state.commit('setOrder', initialOrder());
    },
};
